import OriginTable, { renderMap } from './table';
import Title from './title';
import Count from './count';
import Group from './group';
const OPTable = OriginTable;
OPTable.Title = Title;
OPTable.Count = Count;
OPTable.Group = Group;
OPTable.renderMap = renderMap;
export default OPTable;
